// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PythonIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 145 144">
    <path
      fill="url(#python_svga)"
      fillRule="evenodd"
      d="M59.07 9c-9.88 0-17.9 7.76-17.9 17.33v12h30.99v3.34H27.4c-9.89 0-17.9 7.76-17.9 17.33v26c0 9.57 8.01 17.33 17.9 17.33h10.33V87.67c0-9.58 8.01-17.34 17.9-17.34h33.05c8.37 0 15.15-6.56 15.15-14.66V26.33C103.83 16.76 95.8 9 85.93 9zm-4.13 21.33a6.1 6.1 0 0 0 6.2-6c0-3.31-2.77-6-6.2-6a6.1 6.1 0 0 0-6.2 6c0 3.32 2.78 6 6.2 6"
      clipRule="evenodd"
    />
    <path
      fill="url(#python_svgb)"
      fillRule="evenodd"
      d="M85.93 135c9.88 0 17.9-7.76 17.9-17.33v-12H72.84v-3.34h44.76c9.89 0 17.9-7.76 17.9-17.33V59c0-9.57-8.01-17.33-17.9-17.33h-10.33v14.66c0 9.58-8.01 17.34-17.9 17.34H56.32c-8.37 0-15.15 6.56-15.15 14.66v29.34c0 9.57 8.02 17.33 17.9 17.33zm4.13-21.33a6.1 6.1 0 0 0-6.2 6c0 3.31 2.77 6 6.2 6a6.1 6.1 0 0 0 6.2-6c0-3.32-2.78-6-6.2-6"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="python_svga"
        x1={56.66}
        x2={56.66}
        y1={9}
        y2={102.33}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#327EBD" />
        <stop offset={1} stopColor="#1565A7" />
      </linearGradient>
      <linearGradient
        id="python_svgb"
        x1={88.34}
        x2={88.34}
        y1={41.67}
        y2={135}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA4B" />
        <stop offset={1} stopColor="#F9C600" />
      </linearGradient>
    </defs>
  </svg>,
  "Python",
);
export default PythonIcon;
